// ──────────────────────────────────────────────────────
// Public Footer
// Subtle bottom strip used on the kiosk idle screen and the public
// legal pages (/privacy, /policy). Intentionally muted so it never
// competes with QIO branding — Baynatec credit reads as a discreet
// technology-provider line, not a co-brand.
// ──────────────────────────────────────────────────────
import Link from 'next/link';

const YEAR = new Date().getFullYear();

export function PublicFooter() {
    return (
        <footer
            dir="rtl"
            className="w-full mt-auto"
            style={{
                borderTop: '1px solid #e5e7eb',
                background: '#fafbfc',
                color: '#6b7280',
                fontSize: '12px',
                padding: '16px 16px 18px',
            }}
        >
            <div
                className="mx-auto max-w-5xl flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4 text-center sm:text-right"
            >
                <div className="flex flex-wrap items-center justify-center sm:justify-start gap-x-5 gap-y-2">
                    <Link
                        href="/admin/products"
                        className="hover:underline transition-colors"
                        style={{ color: '#475569' }}
                    >
                        لوحة الإدارة
                    </Link>
                    <Link
                        href="/privacy"
                        className="hover:underline transition-colors"
                        style={{ color: '#475569' }}
                    >
                        سياسة الخصوصية
                    </Link>
                    <Link
                        href="/policy"
                        className="hover:underline transition-colors"
                        style={{ color: '#475569' }}
                    >
                        سياسة الاستخدام
                    </Link>
                </div>

                <div className="flex flex-wrap items-center justify-center sm:justify-end gap-x-3 gap-y-1">
                    <span style={{ color: '#9ca3af' }}>
                        © {YEAR} جميع الحقوق محفوظة.
                    </span>
                    <span aria-hidden="true" style={{ color: '#d1d5db' }}>·</span>
                    <span style={{ color: '#9ca3af' }}>
                        منصة مدعومة تقنيًا بواسطة{' '}
                        <a
                            href="https://baynatec.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:underline"
                            style={{ color: '#475569', fontWeight: 500 }}
                        >
                            Baynatec
                        </a>
                    </span>
                </div>
            </div>
        </footer>
    );
}

export default PublicFooter;
